import {
  addDays,
  startOfMonth,
  getDaysInMonth,
  getDay,
  format,
  compareAsc,
  isEqual,
} from 'date-fns';

export default (date: Date, availableDates: Date[]) => {
  const monthStart = startOfMonth(date);
  const daysInMonth = getDaysInMonth(monthStart);
  const firstDayOfMonth = getDay(monthStart);

  let days = [];
  for (let i = 0; i < 35; i++) {
    const offset = i - firstDayOfMonth;
    const rawDate = addDays(monthStart, offset);

    days.push({
      rawDate,
      dayInMonth: format(rawDate, 'd'),
      month: format(rawDate, 'MMM'),
      blank: i < firstDayOfMonth || i > daysInMonth + firstDayOfMonth - 1,
      active: compareAsc(rawDate, date) === 0,
      available: availableDates.find(date => isEqual(date, rawDate)),
    });
  }

  return days;
};
